import { render } from "./addBuyer.vue?vue&type=template&id=1b1f5ad2&scoped=true"
import script from "./addBuyer.vue?vue&type=script&lang=js"
export * from "./addBuyer.vue?vue&type=script&lang=js"

import "./addBuyer.vue?vue&type=style&index=0&id=1b1f5ad2&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1f5ad2"]])

export default __exports__